import { Form } from "formik";
import styled from "styled-components";

export const Container = styled(Form)``;
